// extracted by mini-css-extract-plugin
export default {"container":"form-item_container__2Xf9T","truncate-table":"form-item_truncate-table__PLhq6","table-text-faded":"form-item_table-text-faded__y7Nll","formItem":"form-item_formItem__5bFQf","isInvalid":"form-item_isInvalid__yzV2u","errors":"form-item_errors__WC343"};
    if(module.hot) {
      // 1793877085001
      var cssReload = require("!../../../../node_modules/.pnpm/css-hot-loader@1.4.4/node_modules/css-hot-loader/hotModuleReplacement.js")(module.id, {"fileMap":"{fileName}"});
      module.hot.dispose(cssReload);
      module.hot.accept(undefined, cssReload);;
    }
  